import React, { useState, useEffect, useRef } from "react";
import { Modal, initMDB } from "mdb-ui-kit";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import AutocompleteAdress from './Autocomplete';
import '@geoapify/geocoder-autocomplete/styles/minimal.css';
import {
    MDBInput,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCheckbox,
    MDBSwitch,
    MDBTextArea,
    MDBFile,
    MDBRadio,
    MDBValidationItem,
    MDBBtn,
    MDBSelect,
} from 'mdb-react-ui-kit';
import Coverings from "./Coverings";
import Gutters from "./Gutters";
import RoofExtensions from "./RoofExtensions";

initMDB({ Modal });


const Step = (props) => {

    switch (props.step.number) {
        case 2:
            return (<StepProjectDocumentation {...props} />);
        case 3:
            return (<StepCoverings {...props} />);
        case 4:
            return (<StepExtensions {...props} />);
        case 5:
            return (<StepGutters {...props} />);
        case 6:
            return (<StepIsolation {...props} />);
        case 7:
            return (<StepContactForm {...props} />);
        case 8:
            return (<StepGdpr {...props} />);
        default:
            return (<div>Step error (default) </div>);
    }
};

export default Step;



const StepProjectDocumentation = (props) => {
    const [files, setFiles] = useState();
    const [filesNote, setFilesNote] = useState("");
    const didMount = useRef(false);


    const fileNamesClass = (files) ? "" : " d-none";
    const fileNames = [];
    var fileSize = 0;
    var fileSizeInMb = 0;

    if (files) {
        Array.from(files).forEach(file => {
            file.typ = 'dokumentace';
            //var filename = file.name.normalize();
            //file.name = filename;
            fileNames.push(file.name);
            fileSize += file.size;
        })
        fileSizeInMb = (fileSize / (1024 * 1024)).toFixed(2);
    }

    // TODO omezit fileType souboru
    function validateFileSize() {
        if (fileSize >= 20000000) {
            let fileInput = document.getElementById('documentationFiles');
            fileInput.value = "";
            fileInput.setCustomValidity('Príliš veľká veľkosť súboru, vyberte menej súborov');
            fileInput.reportValidity();
            setFiles();
        }
        return true;
    }

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
        if (validateFileSize()) { props.step.data = { files, filesNote, fileSize } }
    }, [[files], [filesNote]])


    return (
        <div className="my-5">
            <h6 className='text-uppercase fw-bold text-center'>ZADAJTE SÚBORY S DOKUMENTÁCIOU</h6>
            <MDBCol size='12' lg='8' offsetLg='2'>
                <div id='documentationFilesLabel' className='form-text'>
                    (Môžete vybrať viac súborov, celková veľkosť súborov môže byť maximálne 20MB)
                </div>
                <MDBFile id='documentationFiles' multiple className='my-2'
                    onChange={(e) => { setFiles(e.target.files) }} />
                <MDBRow className={'form-text' + fileNamesClass}>
                    <div>Nahrané sôbory ({fileSizeInMb + "MB"}):
                        {fileNames?.map((fileName, i) => (
                            <span key={fileName} className=''> {i + 1 + ') "' + fileName}"</span>
                        ))}
                    </div>
                </MDBRow>
            </MDBCol>

            {/*<MDBCol size="12" lg='8' offsetLg='2' className="mt-4">*/}
            {/*    <MDBTextArea label='Poznámka' id='documentationNote' rows={4} onChange={(e) => { setFilesNote(e.target.value) }} />*/}
            {/*</MDBCol>*/}
        </div>
    );
}





const StepCoverings = (props) => {
    const [popular, setPopular] = useState(false);

    function extensionsHandler(e) {
        props.stateHandler("extensions", e.target.checked);
    }

    return (
        <div>
            <Coverings popularOnly={popular} {...props} />
            <MDBRow className='mt-5 ms-3'>
                <MDBSwitch id='extensions' name='extensions' defaultChecked={popular}
                    label='Chcem ďalšie voliteľné strešné doplnky'
                    onClick={(e) => { extensionsHandler(e); }} />
            </MDBRow>
        </div>
    )
}





const StepExtensions = (props) => {
    const INIT_VALUES = {
        item1: false,
        item6: "0",
        item12: false,
        item13: false,
    }
    const [values, setvalues] = useState(INIT_VALUES);
    const didMount = useRef(false);

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            props.step.data = { values }
            return;
        }
        props.step.data = { values }
    }, [values])

    async function setStep5Value(item, value) {
        if (!isNaN(value) && value < 0) {
            await setvalues({ ...values, [item]: "" });
        } else if (isNaN(value)) {
            await setvalues({ ...values, [item]: "" });
        } else {
            await setvalues({ ...values, [item]: Number(value) });
        }
    }

    return (
        <div>
            <RoofExtensions {...props} />
        </div>
    );
}





const StepGutters = (props) => {
    return (
        <Gutters {...props} />
    )
}





const StepIsolation = (props) => {
    const didMount = useRef(false);

    // Object of "izolace"
    const [izolace, setIzolace] = useState({
        "rozpisPrvku": true,
        "izolaceTyp": "kompakt",
        "izolaceTloustka": 0,
        "zatepleniPresahu": true,
        "servisniPosouzeniTepelneOchrany": false,
        "konstrukcniVrstvy": [
            {
                "poradi": 0,
                "nazev": "",
                "tloustka": "",
                "miNeboSd": "",
                "lambda": ""
            }
        ],
        "osovaRoztecKrokvi": "",
        "sirkaKrokvi": "",
        "poznamka": "",
        "servisniPosouzeniPripevnovacichVrutu": false,
        "vrutyIzolaceTloustka": "",
        "strechaTvar": "",
        "strechaPlocha": "",
        "strechaSklon": "",
        "vyskaBudovy": "",
        "modelStresnichTasek": "",
        "delkaKrokvi": "",
        "kontralatePrurez": "",
        "kontralateDelka": "",
        "bedneni": false,
        "bedneniMaterial": "",
        "bedneniMm": "",
        "vrutyPoznamka": ""
    });

    // CONSTANTS
    const imgHref = '../prilohy/cenovanabidka/';
    const WIDTHS = {
        basic: [50, 80, 100, 120, 140, 160, 180, 200, 220, 240],
        basicALU: [80, 100, 120, 140, 160, 180, 200, 220, 240],
        kompakt: [50, 80, 100, 120, 140, 160, 180, 200, 220, 240],
        top: [80, 100, 120, 140, 160, 180, 200, 220, 240],
        /*climaComfort: [60, 80, 100, 120, 140],*/
    }
    const CONDUCTIVITY = {
        basic: 'λ=0,024 W/mK',
        basicALU: 'λ=0,022 W/mK',
        kompakt: 'λ=0,024 W/mK',
        top: 'λ=0,022 W/mK',
        /*ClimaComfort: 'λ=0,021 W/mK',*/
    }
    const ISOLATION_NOTES = {
        basic: [
            'Rekonstrukce: 80mm vrstva staré minerální vlny, uzavřená vrstva vzduchu, 120mm BramacTherm Basic, hodnotou součinitele prostupu tepla U=0,15W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi',
            'Rekonstrukce: stará minerální vrstva odstraněna, 140mm BramacTherm Basic, hodnotou součinitele prostupu tepla U=0,16W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi'
        ],
        basicALU: ['Novostavby: 140mm BramacTherm Basic ALU, shora opatřen fólií pro doplňkovou hydroizolaci (např. UNI 2S Resistant), hodnota součinitele prostupu tepla U = 0,15 W/m2K, parotěsná vrstva (např. parotěsná fólie Membran 100 2S) na bednění přes viditelné krokve'],
        kompakt: [
            'Rekonstrukce: 80mm vrstva staré minerální vlny, uzavřená vrstva vzduchu, 120mm BramacTherm Kompakt, hodnotou součinitele prostupu tepla U=0,15W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi',
            'Rekonstrukce: stará minerální vrstva odstraněna, 140mm BramacTherm Kompakt, hodnotou součinitele prostupu tepla U=0,16W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi'
        ],
        top: [
            'Novostavby: 140mm BramacTherm Top, hodnotou součinitele prostupu tepla U=0,15W/m2K, parotěsná/vzduchotěsná vrstva (např. Bramac Membran 100) na bednění přes viditelné krokve',
            'Novostavby: 140mm BramacTherm Top, hodnotou součinitele prostupu tepla U=0,15W/m2K, parotěsná/vzduchotěsná vrstva (např. Bramac Membran 100) pod krokvemi'
        ],
        /*ClimaComfort: [],*/
    }

    const rozpisPrvkuClass = (
        izolace.izolaceTloustka != ""
        && WIDTHS[izolace.izolaceTyp].includes(izolace.izolaceTloustka)
    ) ? "" : " d-none";


    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            props.step.data = izolace;
            return;
        }
        if (!WIDTHS[izolace.izolaceTyp].includes(izolace.izolaceTloustka)) {
            //izolace.izolaceTloustka = WIDTHS[izolace.izolaceTyp][0];
            izolace.izolaceTloustka = 0;
        }
        props.step.data = izolace;
    }, [izolace])


    let emptyRoofLayers = (izolace.konstrukcniVrstvy.length >= 10) ? izolace.konstrukcniVrstvy : [];
    if (emptyRoofLayers.length <= 1) {
        for (let i = 1; i <= 10; i++) {
            const obj = {
                "poradi": i,
                "nazev": "",
                "tloustka": "",
                "miNeboSd": "",
                "lambda": ""
            }
            emptyRoofLayers.push(obj);
        }
    }

    //Variables for html className, to show or hide elements
    let showRozpisPrvku = (izolace.rozpisPrvku) ? "" : "d-none";
    let showSkladbaStrechy = (izolace.servisniPosouzeniTepelneOchrany) ? "" : "d-none";
    let btnColor = "secondary";


    function handleLayers(row, element) {
        row[element.target.id] = element.target.value;
        setIzolace({ ...izolace, konstrukcniVrstvy: emptyRoofLayers });
    }


    function validateCm(elementId) {
        let element = document.getElementById(elementId);
        element.setCustomValidity('');
        if (!element.checkValidity()) {
            element.setCustomValidity('Zadejte pouze číslo');
        }
        element.reportValidity();
    }
    function primaryColorByBool(value) {
        return value ? ' c-primary ' : ' ';
    }


    return (
        <div>
            <MDBContainer>
                <MDBRow className='pb-2'>
                    <MDBRow className='mb-3'>
                        <MDBCol className='align-content-end'>
                            <h5 className='text-uppercase'>PLÁNOVANÁ CELOPLOŠNÁ IZOLÁCIA BRAMACTHERM</h5>
                        </MDBCol>
                        <MDBCol>
                            <MDBBtn color='primary' className='float-end' onClick={() => {
                                document.getElementById('Isolation').click();
                            }}>Odstrániť BramacTherm</MDBBtn>
                        </MDBCol>
                    </MDBRow>
                    <MDBCol size='12' lg="5">

                        <MDBRow className="mt-3">
                            <MDBCol size='6' className='d-grid gap-2 align-content-start'>
                                <h6>Zvoľte typ:</h6>
                                <MDBRadio btn btnColor={btnColor} id='basic' name='izolaceTyp' label='Basic' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'basic')} value='basic'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <MDBRadio btn btnColor={btnColor} id='basicALU' name='izolaceTyp' label='Basic Alu' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'basicALU')} value='basicALU'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <MDBRadio btn btnColor={btnColor} id='kompakt' name='izolaceTyp' label='Kompakt' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'kompakt')} value='kompakt'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <MDBRadio btn btnColor={btnColor} id='top' name='izolaceTyp' label='Top' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'top')} value='top'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <p className="mt-4 ms-1">{CONDUCTIVITY[izolace.izolaceTyp]}</p>
                                {/*<MDBRadio btn btnColor={btnColor} id='climaComfort' name='izolaceTyp' label='Clima Comfort' wrapperClass='izolace-radio'*/}
                                {/*    defaultChecked={(izolace.izolaceTyp === 'climaComfort')} value='climaComfort'*/}
                                {/*    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}*/}
                                {/*/>*/}
                            </MDBCol>
                            <MDBCol size="5" offsetMd='1' className='d-grid gap-2'>
                                <h6>Zvoľte hrúbku:</h6>
                                {WIDTHS[izolace.izolaceTyp].map((width) => (
                                    <MDBRadio key={izolace.izolaceTyp + width} name='width' id={width} value={width}
                                        label={width + " mm"} inline checked={(width == izolace.izolaceTloustka)}
                                        onChange={() => { setIzolace({ ...izolace, izolaceTloustka: width }) }} />
                                ))}
                                <input className='input-hidden' id='isolationWidth'></input>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>

                    <MDBCol size='12' lg="7">
                        <MDBRow className='isolation-images mt-2'>
                            <MDBCol size='4'>
                                <img
                                    src={imgHref + "isolation/bramactherm_view_" + izolace.izolaceTyp + ".jpg"}
                                    className="img-fluid"
                                    alt=""
                                />
                            </MDBCol>
                            <MDBCol size='4'>
                                <img
                                    src={imgHref + "isolation/bramactherm_" + izolace.izolaceTyp + "_1.jpg"}
                                    className="img-fluid"
                                    alt=""
                                />
                            </MDBCol>
                            <MDBCol size='4'>
                                <img
                                    src={imgHref + "isolation/bramactherm_" + izolace.izolaceTyp + "_2.jpg"}
                                    className="img-fluid"
                                    alt=""
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='mt-2'>
                            {/*{ISOLATION_NOTES[izolace.izolaceTyp]?.map((note, i) => (*/}
                            {/*    <MDBCol key={izolace.izolaceTyp + "note" + i}>*/}
                            {/*        <p className="extra-small">*/}
                            {/*            {note}*/}
                            {/*        </p>*/}
                            {/*    </MDBCol>*/}
                            {/*))}*/}
                        </MDBRow>
                        <MDBRow>
                            <p className='mt-3 extra-small fst-italic'>
                                Pozn. : Uvedené skladby strešného plášťa su iba orientačné, existuje veľa ďalších variant.
                            </p>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>


                <div key='rozpisPrvku' className={rozpisPrvkuClass}>
                    <MDBRow className="mt-5">
                        <MDBSwitch id='zatepleni' defaultChecked={izolace.zatepleniPresahu}
                            label='Zateplenie presahov strechy'
                            labelClass={'fs-4 ' + primaryColorByBool(izolace.zatepleniPresahu)}
                            wrapperClass='d-flex align-items-center small'
                            onClick={(e) => { setIzolace({ ...izolace, zatepleniPresahu: !izolace.zatepleniPresahu }); }} />
                    </MDBRow>
                </div>
            </MDBContainer>
        </div>
    );
}





const StepContactForm = (props) => {
    const didMount = useRef(false);
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const didLoad = useRef(false);
    //Input data
    const [objectImage, setObjectImage] = useState();
    const [formData, setFormData] = useState({
        kontakt: {
            typZadavatele: "Investor / koncový zákazník",
            ulice: "",
            obec: "",
            psc: "",
        },
        stavba: {
            obec: "",
            ulice: "",
            investor: "",
            prilohyGps: [],
            prilohyDokumentace: [],
            budovy: [{
                poradi: 0,
                adresa: "",
                ulice: "",
                obec: "",
                psc: "",
                okres: "",
                zemSirka: "",
                zemDelka: ""
            }],
        }
    });
    const [regions, setRegions] = useState();
    const regionsData = regions?.map(region => ({
        text: region.okres,
        value: region.okresKod,
    }));

    useEffect(() => {
        if (didLoad.current) return;
        let isMounted = true;
        const controller = new AbortController();

        const getRegions = async () => {
            try {
                const response = await axiosPrivate.get('/okresy/get', {
                    signal: controller.signal
                }, { maxRedirects: 0 });
                didLoad.current = true;
                isMounted && setRegions(response.data.filter(r => r.okresKod !== "??"));
            } catch (err) {
                //setCoverings(coveringsJson);
            }
        }

        if (auth?.accessToken !== undefined) {
            getRegions();
        } else {
            // setRegions(regionsJson);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [auth]);

    //Behaviour of form
    const [objImgChecked, setObjImgChecked] = useState(false);
    const objImgDisplay = (objImgChecked) ? "" : " d-none";
    const mapDisplay = props.step.showMap;
    const [mapUpdate, setMapUpdate] = useState(false);
    const stavbaUdaje = !(formData.kontakt.typZadavatele === "" || formData.kontakt.typZadavatele === "Investor / koncový zákazník");
    const jeObchodnik = formData.kontakt.typZadavatele === "Obchodník";
    const jePokryvac = formData.kontakt.typZadavatele === "Realizační firma / pokrývač";

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            props.step.data = { formData, objectImage }
            return;
        }

        formData.stavba.budovy[0].poradi = 1
        formData.stavba.budovy[0].adresa = formData.stavba.ulice + ", " + formData.stavba.obec + " " + formData.stavba.psc
        formData.stavba.budovy[0].ulice = formData.stavba.ulice
        formData.stavba.budovy[0].obec = formData.stavba.obec
        formData.stavba.budovy[0].psc = formData.stavba.psc

        setMapUpdate(true);
        props.step.data = { formData, objectImage }
    }, [[formData], [objectImage]])

    function validatePSC(id) {
        document.getElementById(id).reportValidity();
    }

    function setAddressFromMap(address) {
        if (address == undefined) return;
        const addrArr = address.split(",");

        let stavbaUpdate = formData.stavba;
        stavbaUpdate.ulice = addrArr[0];
        stavbaUpdate.obec = addrArr[1];
        stavbaUpdate.psc = addrArr[2];
        stavbaUpdate.budovy = [{
            "okres": "",
            "zemSirka": addrArr[3],
            "zemDelka": addrArr[4]
        }]
        setFormData({ ...formData, stavba: stavbaUpdate })
    }

    function stavbaUdajeDiv() {
        return (jePokryvac) ? (
            <div className={"mt-4"}>
                <h5>Údaje o stavbe:</h5>
                <MDBRow>
                    <MDBCol>
                        <MDBInput id="builderName" label="Meno stavebníka" maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, investor: e.target.value } }) }} />
                    </MDBCol>
                </MDBRow>
                <MDBRow className="my-3">
                    <MDBCol>
                        <MDBInput id="builderTel" label="Telefón na stavebníka" maxLength="50"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, telefon: e.target.value } }) }} />
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol>
                        <MDBInput id="stavebniny" label="Preferované Stavebniny" maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, stavebniny: e.target.value } }) }} />
                    </MDBCol>
                </MDBRow>
            </div>
        ) : (
            <div className={"mt-4"}>
                <h5>Údaje o stavbe:</h5>
                <MDBRow>
                    <MDBValidationItem invalid feedback="Není vyplněno jméno stavebníka">
                        <MDBInput id="builderName" label="Meno stavebníka" required={stavbaUdaje} maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, investor: e.target.value } }) }} />
                    </MDBValidationItem>
                </MDBRow>
                <MDBRow>
                    <MDBValidationItem invalid feedback="Není vyplněn telefon na stavebníka">
                        <MDBInput className="mt-3" id="builderTel" label="Telefón na stavebníka" required={stavbaUdaje} maxLength="50"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, telefon: e.target.value } }) }} />
                    </MDBValidationItem>
                </MDBRow>
            </div>
        );
    }

    function stavbaAddress() {
        return mapDisplay ? (
            <div>
                <h5 className="m-0">Lokalita stavby:</h5>
                <div className='form-text my-2'>
                    Napíšte adresu objektu a potom na mape <b>označte objekt ľavým tlačítkom myši</b>.
                    Miesto môžete upresniť ďalším kliknutím do mapy.
                </div>
                <AutocompleteAdress handler={setAddressFromMap} mapUpdate={mapUpdate} />
            </div>
        ) : (jeObchodnik) ? (
            <span></span>
        ) : (jePokryvac) ? (
            <div>
                <h5 className="mb-3">Lokalita stavby:</h5>
                <MDBRow>
                    <MDBCol>
                        <MDBInput id="stavbaUlice" label="Ulica, č.p." maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, ulice: e.target.value } }) }} />
                    </MDBCol>
                </MDBRow>
                <MDBRow className="mt-3">
                    <MDBCol>
                        <MDBInput id="stavbaObec" label="Obec" maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, obec: e.target.value } }) }} />
                    </MDBCol>
                    <MDBCol>
                        <MDBInput id="pscStavba" label="PSČ" pattern="[0-9]{5}" maxLength="5"
                            onChange={(e) => {
                                setFormData({ ...formData, stavba: { ...formData.stavba, psc: e.target.value } }, validatePSC('pscStavba'));
                            }} />
                    </MDBCol>
                </MDBRow>
            </div>
        ) : (
            <div>
                <h5 className="mb-3">Lokalita stavby:</h5>
                <MDBRow>
                    <MDBValidationItem invalid feedback="Není vyplněna ulice stavby">
                        <MDBInput id="stavbaUlice" label="Ulica, č.p." required maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, ulice: e.target.value } }) }} />
                    </MDBValidationItem>
                </MDBRow>
                <MDBRow className="mt-3">
                    <MDBCol>
                        <MDBValidationItem invalid feedback="Není vyplněna obec stavby">
                            <MDBInput id="stavbaObec" label="Obec" required maxLength="200"
                                onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, obec: e.target.value } }) }} />
                        </MDBValidationItem>
                    </MDBCol>
                    <MDBCol>
                        <MDBValidationItem invalid feedback="Není vyplněno PSČ stavby">
                            <MDBInput id="pscStavba" label="PSČ" required pattern="[0-9]{5}" maxLength="5"
                                onChange={(e) => {
                                    setFormData({ ...formData, stavba: { ...formData.stavba, psc: e.target.value } }, validatePSC('pscStavba'));
                                }} />
                        </MDBValidationItem>
                    </MDBCol>
                </MDBRow>
            </div>
        );
    }

    function handleObjectImageChange(e) {
        const fileInput = e.target;
        const fileSize = Array.from(fileInput.files).reduce((sum, file) => sum + file.size, 0);
        if (fileSize >= 20000000) {
            fileInput.value = "";
            fileInput.setCustomValidity('Príliš veľká veľkosť súboru, vyberte menej súborov');
            fileInput.reportValidity();
            fileInput.setCustomValidity('');
            setObjectImage();
            return;
        }
        setObjectImage(fileInput.files);
    }

    function photoOfBuilding() {
        return (mapDisplay || jeObchodnik) ? (
            <div className="mt-3">
                <MDBCheckbox
                    id='objectImageCheck'
                    label='Fotografie objektu (nepovinné - slúžia k lepšej identifikáci objektu)'
                    defaultChecked={objImgChecked}
                    onChange={() => setObjImgChecked(!objImgChecked)}
                />
                <div className={'form-text' + objImgDisplay}>
                    (Môžete vybrať viac súborov, celková veľkosť súborov môže byť maximálne 20MB)
                </div>
                <MDBFile id='objectImage' multiple onChange={handleObjectImageChange} className={objImgDisplay} />
            </div>
        ) : (<div></div>);
    }

    return (
        <div>
            <form id="kontaktForm">
                <div>
                    <h5>Som:</h5>
                    <MDBRadio name='customerType' id='Investor / koncový zákazník' label='Stavebník / Koncový zákazník' defaultChecked
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    <MDBRadio name='customerType' id='Obchodník' label='Obchodník'
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    <MDBRadio name='customerType' id='Realizační firma / pokrývač' label='Pokrývač / Realizačná firma'
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    <MDBRadio name='customerType' id='Architekt / projektant' label='Architekt / Projektant'
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    {/* <MDBValidationItem invalid feedback="Není vybráno Vaše zaměření">
                        <MDBRadio name='customerType' id='Jiné' label='Oblastní manažéri Bramac' required
                            onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    </MDBValidationItem> */}
                </div>

                <div className="mt-4">
                    <h5>Odosielateľ:</h5>
                    <MDBRow className="my-3">
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadáno jméno odesílatele">
                                <MDBInput id="jmeno" label="Meno" required maxLength="50"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, jmeno: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadáno příjmení odesílatele">
                                <MDBInput id="prijmeni" label="Priezvisko" required maxLength="50"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, prijmeni: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                    </MDBRow>
                    {jeObchodnik ? (
                        <MDBRow>
                            <MDBCol>
                                <MDBInput id="stavebniny" label="Stavebniny" required maxLength="200"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, stavebniny: e.target.value } }) }} />
                            </MDBCol>
                            <MDBCol>
                                <select id="regions" className="form-select" required value={formData.kontakt.okres || "??"}
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, okres: e.target.value, }, }); }} >
                                    <option value="??">Vyberte okres</option>
                                    {regionsData?.map((region) => (
                                        <option key={region.value} value={region.value}>
                                            {region.text}
                                        </option>
                                    ))}
                                </select>
                            </MDBCol>
                        </MDBRow>
                    ) : (
                        <span>
                            <MDBRow>
                                <MDBValidationItem invalid feedback="Není zadána ulice adresy odesílatele">
                                    <MDBInput id="ulice" label="Ulica, č.p." required maxLength="200"
                                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, ulice: e.target.value } }) }} />
                                </MDBValidationItem>
                            </MDBRow>
                            <MDBRow className="my-3">
                                <MDBCol>
                                    <MDBValidationItem invalid feedback="Není zadána obec adresy odesílatele">
                                        <MDBInput id="obec" label="Obec" required maxLength="200"
                                            onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, obec: e.target.value } }) }} />
                                    </MDBValidationItem>
                                </MDBCol>
                                <MDBCol>
                                    <MDBInput id="pscKontakt" label="PSČ" required pattern="[0-9]{5}" maxLength="5"
                                        onChange={(e) => {
                                            setFormData({ ...formData, kontakt: { ...formData.kontakt, psc: e.target.value } }, validatePSC('pscKontakt'));
                                        }} />
                                </MDBCol>
                            </MDBRow>
                        </span>
                    )}
                    <MDBRow className="my-3">
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadán telefon odesílatele">
                                <MDBInput id="telefon" label="Telefón" type="tel" required maxLength="50"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, telefon: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadán e-mail odesílatele">
                                <MDBInput id="email" label="Email" type="email" required maxLength="100"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, email: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                    </MDBRow>
                </div>

                {jeObchodnik || !stavbaUdaje ? (<></>) : stavbaUdajeDiv()}

                <div className={"mt-4"}>
                    {stavbaAddress()}
                    {photoOfBuilding()}
                    <MDBTextArea label='Poznámka' id='buildingNote' rows={6} className="mt-3"
                        onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, poznamka: e.target.value } }) }} />
                </div>
            </form>
        </div>
    );
}





const StepGdpr = (props) => {

    return (
        <div>
            <MDBContainer>
                <p className='mb-3'>
                    Zaškrtnutím pola „Súhlas so spracovaním osobných údajov“ ako subjekt údajov udeľujem týmto spoločnosti
                    BMI Slovensko s.r.o., so sídlom Mojmírovská 9, 951 12 Ivanka pri Nitre, IČ : 31372961, kontaktný email:
                    <a href="mailto:infosk@bmigroup.com" className="c-primary">infosk@bmigroup.com</a>, (ďalej len Správca),
                    dobrovoľný a slobodný súhlas, aby Správca na základe tohoto súhlasu zhromažďoval, uchovával a spracovával
                    moje osobné údaje, a to za nižšie uvedených podmienok:
                </p>
                <ol>
                    <li>Osobné údaje, ktoré budú spracované sú : meno a priezvisko, adresa bydliska, telefonický kontakt, adresa stavby</li>
                    <li>Poskytnutie osobných údajov nie je zákonnou požiadovkou Správcu</li>
                    <li>Subjekt údajov poskytuje osobné údaje dobrovoľne k spracovaniu iba pre nasledujúce účely:</li>
                    <ol className="souhlas1 mb-2">
                        <li>k spracovaniu cenovej ponuky dodávky strešnej krytiny a príslušenstva z portfólia značky BRAMAC zo strany Správcu, ktorú si vyžiadal subjekt údajov</li>
                        <li>pre marketingové účely</li>
                    </ol>
                    <li>Osobné údaje nebudú poskytované tretím osobám a do tretích zemí</li>
                    <li>Spracovanie osobných údajov subjektu údajov bude manuálne a automatizované</li>
                    <li>Práva subjektu údajov:</li>
                    <ol className="souhlas1 mb-2">
                        <li>právo kedykoľvek odvolať v celom rozsahu svoj súhlas so spracovaním osobných údajov, a to písomnou alebo elektronickou formou ( zahrňuje aj právo odvolať súhlas so spracovaním osobných údajov iba k niektorým účelom, ktoré sú uvedené v odst.3 tohto súhlasu)</li>
                        <li>právo požadovať od prevádzkovateľa prístup k svojim osobným údajom, ich opravu alebo vymazanie, prípadne obmedzenie spracovania a namietať proti spracovaniu</li>
                        <li>právo ma prenositeľnosť týchto údajov k inému Správcovi</li>
                        <li>právo podať sťažnosť dozorovému orgánu, ktorým je Úrad na ochranu osobných údajov</li>
                    </ol>
                    <li>Súhlas podľa tohto odstavca sa udeľuje na dobu maximálne 10 rokov od jeho udelenia</li>
                    <li>Subjekt údajov potvrdzuje, ze vyššie uvedenému poučeniu rozumie a že poskytnuté osobné údaje sú presné a pravdivé</li>
                </ol>
            </MDBContainer>
        </div>
    );
}

